import type { GameProfile, ProfileCtx } from "./types";

import abioticFactor from "./abioticFactor";
import accProfile from "./acc";
import aloft from "./aloft";
import ardem from "@/game_profiles/ardem";
import ardemOfficial from "@/game_profiles/ardemOfficial";
import arkAscended from "./arkAscended";
import astroColony from "./astroColony";
import astroneer from "./astroneer";
import beamMP from "./beamMP";
import bungeecord from "./bungeecord";
import conanExilesPcOfficial from "./conanExilesPcOfficial";
import conanExilesPrivate from "./conanExilesPrivate";
import conanExilesPSPrivate from "./conanExilesPSPrivate";
import conanExilesUE5PcOfficial from "./conanExilesUE5PcOfficial";
import conanExilesXboxPrivate from "./conanExilesXboxPrivate";
import CoreKeeper from "./coreKeeper";
import cryoFall from "./cryoFall";
import cs2 from "./cs2";
import csgoProfile from "./csgo";
import cubicOdyssey from "./cubicOdyssey";
import dayZ from "./dayZ";
import deadlock from "./deadlock";
import deadside from "./deadside";
import deadsideConsole from "./deadsideConsole";
import defaultProfile from "./default";
import duckside from "./duckside";
import duneAwakening from "./duneAwakening";
import duneAwakeningConsole from "./duneAwakeningConsole";
import EchoesOfElysium from "./echoesOfElysium";
import eco from "./eco";
import enshrouded from "./enshrouded";
import exfil from "./exfil";
import factorio from "./factorio";
import farmingSimulatorProfile from "./farmingSimulator";
import FiveM from "./fiveM";
import FiveMEnhanced from "./fiveMEnhanced";
import foundry from "./foundry";
import guardiansOfTheWildSky from "./guardiansOfTheWildSky";
import hellLetLoose from "./hellLetLoose";
import hellLetLooseOfficial from "./hellLetLooseOfficial";
import humanitZ from "./humanitZ";
import hytale from "./hytale";
import icarusProfile from "./icarus";
import karagonProfile from "./karagon";
import leapProfile from "./leap";
import Lotr_moria from "./lotr_moria";
import mercenaryCorps from "./mercenaryCorps";
import minecraftProfile from "./minecraft";
import motorTown from "./motorTown";
import necesse from "./necesse";
import nightingale from "./nightingale";
import noOneSurvived from "./noOneSurvived";
import outOfAction from "./outOfAction";
import overTheTopWWI from "./overTheTopWWI";
import palworld from "./palworld";
import projectZomboid from "./projectZomboid";
import RedM from "./redM";
import romestead from "./romestead";
import riseAndReign from "./riseAndReign";
import runeScapeDragonwilds from "./runeScapeDragonwilds";
import rustConsoleProfile from "./rustConsole";
import saleblazers from "./saleblazers";
import satisfactory from "./satisfactory";
import SCP5K from "./scp5k";
import scum, { scumDev } from "./scum";
import sevenDaysToDie from "./sevenDaysToDie";
import sevenDaysToDieConsole from "./sevenDaysToDieConsole";
import shipsAtSea from "./shipsAtSea";
import smalland from "./smalland";
import smallandConsole from "./smallandConsole";
import sonsOfTheForestProfile from "./sonsOfTheForest";
import soulmask from "./soulmask";
import squad44 from "./squad44";
import starRupture from "./starRupture";
import surviveTheNights from "./surviveTheNights";
import terraTechWorlds from "./terraTechWorlds";
import theFrontProfile from "./theFront";
import theIsleProfile from "./theIsle";
import theIsleEvrimaProfile from "./theIsleEvrima";
import totallyAccurateBattlegroundsProfile from "./totallyAccurateBattlegrounds";
import valheim from "./valheim";
import vein from "./vein";
import vintageStory from "./vintageStory";
import voyagersOfNera from "./voyagers_of_nera";
import vRising from "./vRising";
import vRisingConsole from "./vRisingConsole";
import wreckfest from "./wreckfest";
import wardogs from "./wardogs";
import windrose from "./windrose";
import wukongMP from "./wukongMP";
import truckSimulator from "./truckSimulator";

// @ts-ignore
const profileCreators: Record<string, (ctx: ProfileCtx) => Partial<GameProfile>> = {
  ACC: accProfile,
  ACCPlaystation: accProfile,
  ACCXbox: accProfile,
  ACCUwp: accProfile,
  AbioticFactor: abioticFactor,
  AbioticFactorUwp: abioticFactor,
  Aloft: aloft,
  Ardem: ardem,
  ArdemOfficial: ardemOfficial,
  ArkAscended: arkAscended,
  AstroColony: astroColony,
  Astroneer: astroneer,
  BeamMP: beamMP,
  Bungeecord: bungeecord,
  ConanExilesPSPrivate: conanExilesPSPrivate,
  ConanExilesPcOfficial: conanExilesPcOfficial,
  ConanExilesUE5PcOfficial: conanExilesUE5PcOfficial,
  ConanExilesPrivate: conanExilesPrivate,
  ConanExilesXboxPrivate: conanExilesXboxPrivate,
  CoreKeeper: CoreKeeper,
  CryoFall: cryoFall,
  Cs2: cs2,
  Csgo: csgoProfile,
  CubicOdyssey: cubicOdyssey,
  DayZ: dayZ,
  Deadlock: deadlock,
  Deadside: deadside,
  DeadsideConsole: deadsideConsole,
  DeadsideUwp: deadsideConsole,
  Duckside: duckside,
  DucksideConsole: duckside,
  DucksideUWP: duckside,
  DuneAwakening: duneAwakening,
  DuneAwakeningConsole: duneAwakeningConsole,
  DuneAwakeningUwp: duneAwakeningConsole,
  EchoesOfElysium,
  Eco: eco,
  Enshrouded: enshrouded,
  EnshroudedPS5: enshrouded,
  Exfil: exfil,
  Factorio: factorio,
  FarmingSimulator: farmingSimulatorProfile,
  FarmingSimulatorUwp: farmingSimulatorProfile,
  FiveM: FiveM,
  FiveMEnhanced: FiveMEnhanced,
  Foundry: foundry,
  GuardiansOfTheWildSky: guardiansOfTheWildSky,
  HellLetLoose: hellLetLoose,
  HellLetLooseOfficial: hellLetLooseOfficial,
  HellLetLooseUwp: hellLetLoose,
  HumanitZ: humanitZ,
  Hytale: hytale,
  Icarus: icarusProfile,
  Karagon: karagonProfile,
  Leap: leapProfile,
  LotrMoria: Lotr_moria,
  MercenaryCorps: mercenaryCorps,
  Minecraft: minecraftProfile,
  Necesse: necesse,
  Nightingale: nightingale,
  NoOneSurvived: noOneSurvived,
  OverTheTopWWI: overTheTopWWI,
  OutOfAction: outOfAction,
  Palworld: palworld,
  PalworldPS5: palworld,
  PalworldUwp: palworld,
  PalworldXbox: palworld,
  ProjectZomboidProfile: projectZomboid,
  RedM: RedM,
  Romestead: romestead,
  RiseAndReign: riseAndReign,
  RuneScapeDragonwilds: runeScapeDragonwilds,
  RuneScapeDragonwildsUwp: runeScapeDragonwilds,
  RustConsole: rustConsoleProfile,
  RustConsoleUwp: rustConsoleProfile,
  SCP5K: SCP5K,
  Saleblazers: saleblazers,
  Satisfactory: satisfactory,
  Scum: scum,
  ScumDev: scumDev,
  SevenDaysToDie: sevenDaysToDie,
  SevenDaysToDieConsole: sevenDaysToDieConsole,
  ShipsAtSea: shipsAtSea,
  Smalland: smalland,
  SmallandUwp: smallandConsole,
  SonsOfTheForest: sonsOfTheForestProfile,
  Soulmask: soulmask,
  Squad44: squad44,
  StarRupture: starRupture,
  SurviveTheNights: surviveTheNights,
  SurviveTheNightsDev: surviveTheNights,
  SurviveTheNightsOfficial: surviveTheNights,
  TerraTechWorlds: terraTechWorlds,
  TheFront: theFrontProfile,
  TheIsle: theIsleProfile,
  TheIsleEvrima: theIsleEvrimaProfile,
  TotallyAccurateBattlegrounds: totallyAccurateBattlegroundsProfile,
  VRising: vRising,
  VRisingConsole: vRisingConsole,
  Valheim: valheim,
  // Console and the Microsoft Store SKU run the same panel as PC — mods, ValheimPlus and save
  // management are all there, and the only difference (forced crossplay) is enforced server-side.
  ValheimConsole: valheim,
  ValheimUwp: valheim,
  VintageStory: vintageStory,
  VoyagersOfNera: voyagersOfNera,
  Wreckfest: wreckfest,
  MotorTown: motorTown,
  Wardogs: wardogs,
  Windrose: windrose,
  WukongMP: wukongMP,
  Vein: vein,
  EuroTruckSimulator2Profile: truckSimulator,
  AmericanTruckSimulatorProfile: truckSimulator,
};

function buildProfile(ctx: ProfileCtx): GameProfile | undefined {
  const gameProfileName = ctx?.profile?.name;

  if (gameProfileName) {
    // allow just using the default frontend profile w/o any overrides
    const specificProfileCreator = profileCreators[gameProfileName];
    if (specificProfileCreator) {
      return {
        ...defaultProfile(ctx),
        ...specificProfileCreator(ctx),
      };
    } else {
      return defaultProfile(ctx);
    }
  }
}

export { default as defaultProfile } from "./default";
export default buildProfile;
